<!--
 * @Author: liukai
 * @since: 2022-04-19 09:07:25
 * @LastAuthor: liukai
 * @lastTime: 2022-04-27 09:52:27
-->
<template>
  <div class="searchPage">
    <!-- <Nav title="出行防疫政策查询"></Nav> -->
    <div class="focus">
      <img :src="bg" alt />
      <!-- <div class="notice_bar">
        <van-notice-bar
          scrollable
          color="#444"
          background="#ecf9ff"
          left-icon="volume-o"
        >米袋虽空——樱花开哉！</van-notice-bar>
      </div> -->
    </div>
    <div class="search_list">
      <div class="search_plate">
        <div class="up_part">
          <div class="city_select van-hairline--bottom">
            <div class="user_city" @click="handleClickOut">
              <span>{{address?.out[1]?.name||'选择出发地'}}</span>
              <img :src="down_arrow" alt />
            </div>
          </div>
          <img class="exchange" :src="pic_exchange" alt />
          <div class="city_select van-hairline--bottom">
            <div class="user_city" @click="handleClickDesti">
              <span>{{address?.origin[1]?.name||'选择目的地'}}</span>
              <img :src="down_arrow" alt />
            </div>
          </div>
        </div>
        <div class="search_btn">
          <van-button color="#2C71C1" size="large" type="primary" round @click="handleSearch">查询出行政策</van-button>
        </div>
      </div>
      <p class="tips">内容综合当地卫健委和权威网站，可能更新不及时或有错漏，建议出行前与防疫部门再次确认。</p>
      <div class="item" v-if="leave_policy.city&&back_policy.city">
        <div class="block"></div>
        <span>出行政策</span>
      </div>
      <div class="result" v-if="leave_policy.city&&back_policy.city" >
        <div class="thead">
          <div class="left_part">
            <img :src="pic_come" alt />
            <span class="address">{{leave_policy.city}}</span>
          </div>
          <div class="right_part">
            <div class="hight_tag_group" v-if="leave_policy.high_num>0">
              <van-tag
                color="#ffeae9"
                text-color="#DB2F20"
                class="covid_tag_noright"
                size="medium"
              >高风险地区</van-tag>
              <van-tag color="#DB2F20" class="covid_tag_noleft" type="primary" size="medium">{{leave_policy.high_num}}个</van-tag>
            </div>
            <div class="medium_tag_group" v-if="leave_policy.medium_num>0">
              <van-tag
                color="#fff2e2"
                text-color="#ED9027"
                class="covid_tag_noright"
                size="medium"
              >中风险地区</van-tag>
              <van-tag color="#ED9027" class="covid_tag_noleft" type="primary" size="medium">{{leave_policy.medium_num}}个</van-tag>
            </div>
            <div class="low_tag_group" v-if="leave_policy.high_num==0&&leave_policy.medium_num==0">
              <van-tag color="#e8ffe8" text-color="#09BB07" class="covid_tag" size="medium">低风险地区</van-tag>
            </div>
          </div>
        </div>

        <div class="origin_title">离开政策</div>
        <div
          :class="{'origin_info':true,'sixLine':showMoreLeave,}"
        >{{leave_policy.policy}}</div>
        <div class="origin_footer" v-show="showMoreLeave">
          <div @click="handleMoreLeave">
            <span>查看更多</span>
            <img :src="piv_more" alt />
          </div>
        </div>
      </div>
      <div class="result come" v-if="leave_policy.city&&back_policy.city">
        <div class="thead">
          <div class="left_part">
            <img :src="pic_out" alt />
            <span class="address">{{back_policy.city}}</span>
          </div>
          <div class="right_part">
            <div class="hight_tag_group" v-if="back_policy.high_num>0">
              <van-tag
                color="#ffeae9"
                text-color="#DB2F20"
                class="covid_tag_noright"
                size="medium"
              >高风险地区</van-tag>
              <van-tag color="#DB2F20" class="covid_tag_noleft" type="primary" size="medium">{{back_policy.high_num}}个</van-tag>
            </div>
            <div class="medium_tag_group" v-if="back_policy.medium_num>0">
              <van-tag
                color="#fff2e2"
                text-color="#CA6B00"
                class="covid_tag_noright"
                size="medium"
              >中风险地区</van-tag>
              <van-tag color="#CA6B00" class="covid_tag_noleft" type="primary" size="medium">{{back_policy.medium_num}}个</van-tag>
            </div>
            <div class="low_tag_group" v-if="back_policy.high_num==0&&back_policy.medium_num==0">
              <van-tag color="#e8ffe8" text-color="#09BB07" class="covid_tag" size="medium">低风险地区</van-tag>
            </div>
          </div>
        </div>

        <div class="origin_title">到达政策</div>
        <div
          :class="{'origin_info':true,'sixLine':showMoreBack,}"
        >{{back_policy.policy}}</div>
        <div class="origin_footer" v-show="showMoreBack">
          <div @click="handleMoreBack">
            <span>查看更多</span>
            <img :src="piv_more" alt />
          </div>
        </div>
      </div>
    </div>
    <CityPopup ref="OutpopupRef" @confirm="getOut"></CityPopup>
    <CityPopup ref="DestipopupRef" @confirm="getCome"></CityPopup>
  </div>
</template>

<script>
import { reactive, onMounted, toRefs, ref } from "vue";
import Nav from "@/components/nav-bar.vue";
import CityPopup from "@/components/cityPopup.vue";
import { Tag, NoticeBar, Button, Toast } from "vant";
import { getpolicy } from "@/api/";
export default {
  name: "Search",
  components: {
    Nav,
    CityPopup,
    [Tag.name]: Tag,
    [NoticeBar.name]: NoticeBar,
    [Button.name]: Button,
    [Toast.name]: Toast,
  },
  setup() {
    const data = reactive({
      bg: require("@/assets/img/search.jpg"),
      pic_out: require("@/assets/img/text_out.png"),
      pic_come: require("@/assets/img/text_come.png"),
      piv_more: require("@/assets/img/more.png"),
      down_arrow: require("@/assets/img/down_arrow.png"),
      pic_exchange: require("@/assets/img/exchange.png"),
      showMoreLeave: true,
      showMoreBack: true,
      address: {
        out: "",
        origin: "",
      },
      back_policy: {
        city: "",
        high_num: null,
        medium_num: null,
        policy:"暂无相关信息",
      },
        leave_policy: {
          city: "",
          high_num: null,
          medium_num: null,
          policy: "暂无相关信息",
        },
    });
    // const address={
    //       out:'',
    //       origin:''
    //   }
    const OutpopupRef = ref(null);
    const DestipopupRef = ref(null);
    const methodsMap = {
      handleMoreLeave: () => {
        data.showMoreLeave = !data.showMoreLeave;
      },
      handleMoreBack: () => {
        data.showMoreBack = !data.showMoreBack;
      },
      handleClickOut: () => {
        OutpopupRef.value.popUp();
      },
      handleClickDesti: () => {
        DestipopupRef.value.popUp();
      },
      getOut: (res) => {
        console.log(res, "out");
        data.address.out = res;
      },
      getCome: (res) => {
        console.log(res, "origin");
        data.address.origin = res;
      },
      handleSearch: () => {
        if (data.address.out.length < 1) {
          Toast("请选择出发地");
          return false;
        }
        if (data.address.origin.length < 1) {
          Toast("请选择目的地");
          return false;
        }

        let param = {
          leave_code: data.address["out"][1].code,
          back_code: data.address["origin"][1].code,
        };
        // 初始化折叠按钮
        data.showMoreLeave=true;
        data.showMoreBack=true;

        getpolicy(param).then((res) => {
          if (res.data.code == 0) {
              data.leave_policy=res.data.data.leave_policy
              data.back_policy=res.data.data.back_policy
          } else {
          }
          console.log(res, "res");
        });
        console.log(param, "search");
      },
    };
    return {
      OutpopupRef,
      DestipopupRef,
      ...toRefs(data),
      ...methodsMap,
    };
  },
};
</script>

<style lang="scss">
@import "@/css/wap/mixin.scss";
.searchPage {
  width: 375px;
  overflow-x: hidden;
  box-sizing: border-box;
  font-family: PingFang SC;
  position: relative;
  background: #f7f7f7;
  min-height: 100vh;
  .focus {
    width: 375px;
    height: 164px;
    position: relative;
    .notice_bar {
      width: 345px;
      position: absolute;
      bottom: 5px;
      left: 15px;
      border-radius: 8px;
      overflow: hidden;
    }
    img {
      width: 375px;
      height: 164px;
    }
  }
  .search_plate {
    position: absolute;
    top: -12px;
    left: 15px;
    width: 345px;
    height: 128px;
    border-radius: 12px;
    box-shadow: 0px 3px 5px #0000000f;
    background-color: #fff;
    box-sizing: border-box;
    padding: 15px;
    .up_part {
      display: flex;
      justify-content: space-evenly;
      align-items: center;

      width: 315px;
      height: 32px;
      .city_select {
        width: 121px;
        height: 32px;
        padding-bottom: 10px;
        .user_city {
          height: 32px;
          display: flex;
          justify-content: space-evenly;
          align-items: center;
          span {
            color: #999999;
            font-weight: 500;
            font-size: 14px;
          }
          img {
            width: 24px;
            height: 24px;
          }
        }
      }
      .exchange {
        width: 24px;
        height: 24px;
      }
    }
    .search_btn {
      margin-top: 15px;
    }
  }
  .search_list {
    position: relative;
    padding-top: 128px;
    .tips {
      margin: 0 auto;
      width: 315px;
      color: #999999;
      font-family: PingFang SC;
      font-weight: 500;
      font-size: 12px;
      line-height: 1.45;
    }
    .item {
      margin: 16px auto;
      width: 345px;
      height: 22px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .block {
        width: 3px;
        height: 18px;
        background-color: #2c71c1;
      }
      span {
        color: #444444;
        font-family: PingFang SC;
        font-weight: bold;
        font-size: 16px;
        margin-left: 11px;
      }
    }

    .result {
      width: 345px;
      padding: 15px;
      box-sizing: border-box;
      margin: 0 auto;
      background-color: #fff;
      border-radius: 4px;

      .thead {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .left_part {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          img {
            width: 18px;
            height: 18px;
          }
          .address {
            color: #444444;
            font-family: PingFang SC;
            font-weight: bold;
            font-size: 16px;
            margin-left: 8px;
          }
        }
        .right_part {
          display: flex;
          justify-content: flex-end;
          align-items: center;

          .hight_tag_group {
            .covid_tag_noright {
              border-top-right-radius: 0 !important;
              border-bottom-right-radius: 0 !important;
              border: 1px solid #db2f20;
            }
            .covid_tag_noleft {
              border-top-left-radius: 0 !important;
              border-bottom-left-radius: 0 !important ;
              border: 1px solid #db2f20;
            }
          }
          .medium_tag_group {
            margin-left: 8px;
            .covid_tag_noright {
              border-top-right-radius: 0 !important;
              border-bottom-right-radius: 0 !important;
              border: 1px solid #ed9027;
            }
            .covid_tag_noleft {
              border-top-left-radius: 0 !important;
              border-bottom-left-radius: 0 !important ;
              border: 1px solid #ed9027;
            }
          }
          .low_tag_group {
            .covid_tag {
              border: 1px solid #09bb07;
            }
          }
        }
      }
      .origin_title {
        color: #444444;
        font-weight: bold;
        font-size: 14px;
        margin-top: 14px;
      }
      .origin_info {
        width: 315px;
        color: #444444;
        font-weight: 500;
        font-size: 14px;
        line-height: 24px;
        margin-top: 8px;
        transition: all 0.5s;
      }
      .sixLine {
        @include noWrapN(6);
      }

      .origin_footer {
        width: 315px;
        height: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        div {
          display: flex;
          justify-content: center;
          align-items: center;
          span {
            color: #444444;
            font-weight: 500;
            font-size: 14px;
          }
          img {
            width: 18px;
            height: 18px;
            margin-left: 5px;
          }
        }
      }
    }
    .come {
      margin-top: 12px;
    }
  }
}
</style>